<template>
    <v-form v-model="validForm" lazy-validation>
        <v-card style="background-color: transparent" class="elevation-0 mx-0">
            <div>
                <v-tabs v-model="step" fixed-tabs>
                    <v-tab value="1" href="#1" style="justify-content: left">
                        <v-btn
                            :color="step === '1' ? 'primary' : '_grey'"
                            data-cy="BudgetFormFull-finance"
                            size="x-small"
                            class="pr-2"
                        >
                            1
                        </v-btn>
                        <div class="d-flex align-center justify-center pl-4">Financement</div>
                    </v-tab>
                    <v-tab value="2" href="#2" style="justify-content: left">
                        <v-btn
                            :color="step === '2' ? 'primary' : '_grey'"
                            data-cy="BudgetFormFull-activity"
                            size="x-small"
                            class="pr-2"
                        >
                            2
                        </v-btn>
                        <div class="d-flex align-center justify-center pl-4">Activité</div>
                    </v-tab>
                    <v-tab value="3" href="#3" style="justify-content: left">
                        <v-btn
                            :color="step === '3' ? 'primary' : '_grey'"
                            data-cy="BudgetFormFull-fillers"
                            size="x-small"
                            class="pr-2"
                        >
                            3
                        </v-btn>
                        <div class="d-flex align-center justify-center pl-4">Charges</div>
                    </v-tab>
                    <v-tab value="4" href="#4" style="justify-content: left">
                        <v-btn
                            :color="step === '4' ? 'primary' : '_grey'"
                            data-cy="BudgetFormFull-staff"
                            size="x-small"
                            class="pr-4"
                        >
                            4
                        </v-btn>
                        <div class="d-flex align-center justify-center pl-4">Personnel</div>
                    </v-tab>
                </v-tabs>
                <v-tabs-window v-model="step">
                    <!-- STEP 1 - FINANCEMENTS -->
                    <v-window-item value="1">
                        <v-card style="box-shadow: none">
                            <v-card-text>
                                <!--<v-row no-gutters>
                                    <h2>Financements</h2>
                                </v-row> -->
                                <!-- <v-spacer></v-spacer> -->
                                <v-expansion-panels
                                    v-model="fundingsExpanded"
                                    multiple
                                    accordion
                                    style="box-shadow: none"
                                >
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Apports en capital</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="formBff.fundings.capitalContributions"
                                                :headers="capitalContributionsHeaders"
                                                :itemsPerPage="
                                                    formBff.fundings.capitalContributions.length
                                                "
                                                hide-default-footer
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <!-- <v-select
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                required
                                                                class="oss-"
                                                                hide-details="auto"
                                                            ></v-select> -->
                                                            <v-combobox-filled
                                                                v-if="selectedPartition"
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-text-field-filled
                                                                v-model="props.item.title"
                                                                hide-details="auto"
                                                                density="compact"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-date-picker-filled
                                                                :model-value="
                                                                    transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                "
                                                                type="month"
                                                                format="MM-YYYY"
                                                                :text-field-readonly="false"
                                                                hide-details="auto"
                                                                @change-date="assignItemDate"
                                                                @close="
                                                                    transformDateToGap(props.item)
                                                                "
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                v-model="props.item.amount"
                                                            />
                                                        </td>
                                                        <td cols="1" class="pl-4 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType =
                                                                                'capitalContribution';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div class="d-flex justify-end mr-8">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="
                                                                        addCapitalContribution()
                                                                    "
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <!-- <div class="d-flex justify-end">
                                                                <v-btn
                                                                    color="primary"

                                                                    fab
                                                                        size=“x-small”
                                                                    elevation="0"
                                                                    @click="addCapitalContribution()"
                                                                    v-if="props.index + 1 === formBff.fundings.capitalContributions.length"
                                                                >
                                                                    <v-icon>$add</v-icon>
                                                                </v-btn>
                                                            </div> -->
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Apports en comptes courants</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="
                                                    formBff.fundings.currentAccountContributions
                                                "
                                                :headers="currentAccountContributionsHeaders"
                                                :itemsPerPage="
                                                    formBff.fundings.currentAccountContributions
                                                        .length
                                                "
                                                hide-default-footer
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <!-- <v-select
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                hide-details="auto"
                                                            ></v-select> -->
                                                            <v-combobox-filled
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-text-field-filled
                                                                v-model="props.item.name"
                                                                hide-details="auto"
                                                                density="compact"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-date-picker-filled
                                                                :date="
                                                                    transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                "
                                                                @change-date="assignItemDate"
                                                                @close="
                                                                    transformDateToGap(props.item)
                                                                "
                                                                type="month"
                                                                format="MM-YYYY"
                                                                :text-field-readonly="false"
                                                                hide-details="auto"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                v-model="props.item.amount"
                                                            />
                                                        </td>
                                                        <td class="pl-4 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType =
                                                                                'currentAccountContribution';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div class="d-flex justify-end mr-8">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="
                                                                        addCurrentAccountContribution()
                                                                    "
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Emprunts</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="formBff.fundings.loans"
                                                :headers="loansHeaders"
                                                :itemPerPage="formBff.fundings.loans.length"
                                                hide-default-footer
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <!-- <v-select
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                hide-details="auto"
                                                            ></v-select> -->
                                                            <v-combobox-filled
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td
                                                            class="py-0 pl-0 pr-2 ma-0"
                                                            :colspan="2"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.title"
                                                                hide-details="auto"
                                                                density="compact"
                                                            />
                                                        </td>
                                                        <!-- <td class="py-0 pl-0 pr-2 ma-0">
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ props}">
                                                                    <v-icon
                                                                        v-on="{...tooltip}"
                                                                    >$oss-analysis</v-icon>
                                                                </template>
                                                                <span>Détail de la ligne</span>
                                                            </v-tooltip>
                                                        </td> -->
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-date-picker-filled
                                                                :date="
                                                                    transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                "
                                                                v-bind="props"
                                                                @change-date="assignItemDate"
                                                                @close="
                                                                    transformDateToGap(props.item)
                                                                "
                                                                type="month"
                                                                format="MM-YYYY"
                                                                :text-field-readonly="false"
                                                                hide-details="auto"
                                                                @change="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                @change="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                                v-model="props.item.amount"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                @change="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                                v-model="props.item.rate"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.duration"
                                                                :items="durationDelays"
                                                                item-value="id"
                                                                required
                                                                hide-details="auto"
                                                                @update:model-value="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.periodicity"
                                                                :items="loanPeriodicity"
                                                                item-value="id"
                                                                required
                                                                hide-details="auto"
                                                                @update:model-value="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                @change="
                                                                    computeLoanAmounts(props.item)
                                                                "
                                                                v-model="props.item.insuranceRate"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-text-field-filled
                                                                disabled
                                                                hide-details="auto"
                                                                v-model="props.item.monthlyAmount"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <oss-text-field-filled
                                                                disabled
                                                                hide-details="auto"
                                                                v-model="props.item.totalCost"
                                                            />
                                                        </td>
                                                        <td class="pl-2 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType = 'loan';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div class="d-flex justify-end mr-2">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="addLoan()"
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Subventions d'investissement</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="formBff.fundings.investmentGrants"
                                                :headers="investmentGrantHeaders"
                                                :itemsPerPage="
                                                    formBff.fundings.investmentGrants.length
                                                "
                                                hide-default-footer
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <!-- <v-select
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                hide-details="auto"
                                                            ></v-select> -->
                                                            <v-combobox-filled
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-text-field-filled
                                                                v-model="props.item.title"
                                                                hide-details="auto"
                                                                density="compact"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-date-picker-filled
                                                                :date="
                                                                    transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                "
                                                                @change-date="assignItemDate"
                                                                @close="
                                                                    transformDateToGap(props.item)
                                                                "
                                                                type="month"
                                                                format="MM-YYYY"
                                                                :text-field-readonly="false"
                                                                hide-details="auto"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                v-model="props.item.amount"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.amortizationLaw"
                                                                :items="investmentsAmortizationLaws"
                                                                item-value="id"
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select-filled
                                                                v-model="
                                                                    props.item.amortizationDuration
                                                                "
                                                                :items="durationDelays"
                                                                item-value="id"
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-3 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType =
                                                                                'investmentGrant';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div class="d-flex justify-end mr-3">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="addInvestmentGrant()"
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-center align-end">
                                <v-btn-prev @click="previous()" />
                                <v-btn-next @click="next()" />
                            </v-card-actions>
                        </v-card>
                    </v-window-item>
                    <!-- STEP 2 - ACTIVITIES -->
                    <v-window-item value="2">
                        <v-card style="box-shadow: none">
                            <v-data-table
                                :items="formBff.activities"
                                :headers="activitiesHeaders"
                                :itemsPerPage="formBff.activities.length"
                                :single-expand="false"
                                v-model:expanded="activitiesExpanded"
                                show-expand
                                hide-default-footer
                                class="table"
                            >
                                <template v-slot:item="props">
                                    <tr>
                                        <td class="pl-0 pr-1 py-0 ma-0" v-if="selectedPartition">
                                            <!-- <v-select
                                                    v-model="props.item.tag"
                                                    :items="tagsSelection"
                                                    item-text="name"
                                                    item-value="id"


                                                    dense
                                                    class="oss-"
                                                    hide-details="auto"
                                                ></v-select> -->
                                            <v-combobox-filled
                                                v-model="props.item.tag"
                                                :items="tagsSelection"
                                                item-value="id"
                                                dense
                                                hide-details="auto"
                                                @change="updateTagsSelection(props.item)"
                                                :item-title="(item) => item.name"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0" :colspan="2">
                                            <v-text-field-filled
                                                v-model="props.item.title"
                                                hide-details="auto"
                                                data-cy="BudgetFormFull-libelle"
                                                density="compact"
                                            />
                                        </td>
                                        <!-- <td class="pl-0 pr-1 py-0 ma-0">
                                                <v-select
                                                    v-model="props.item.sector"
                                                    :items="activitiesSectors"


                                                    dense
                                                    required
                                                    class="oss-"
                                                    hide-details="auto"
                                                ></v-select>
                                            </td> -->
                                        <td
                                            class="pl-0 pr-1 py-0 ma-0"
                                            v-if="
                                                availableSalesAccounts.length &&
                                                availableSalesAccounts.length > 0
                                            "
                                        >
                                            <v-select-filled
                                                v-model="props.item.salesAccount"
                                                :items="availableSalesAccounts"
                                                item-value="name"
                                                hide-details="auto"
                                                :disabled="
                                                    props.item.isLineReported &&
                                                    groupingMode === 'AA'
                                                "
                                                density="compact"
                                                :item-title="(item) => item.description"
                                            />
                                        </td>
                                        <td class="pl-2 pr-0 py-0 ma-0">
                                            <v-checkbox
                                                v-model="props.item.activeReporting"
                                                :ripple="false"
                                                :disabled="!props.item.isLineReported"
                                                @update:model-value="onReportingChanged(props.item)"
                                            >
                                            </v-checkbox>
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                disabled
                                                v-model="props.item.amountNM1"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 0) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        false,
                                                        updateAllWhenFirstYearChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                v-model="props.item.years[0].evolutionPercentage"
                                            /><!--@change="updateAllWhenFirstYearChange(props.item, false); buildActivityDefaultDetails(props.item)" -->
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 0) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        true,
                                                        updateAllWhenFirstYearChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                data-cy="BudgetFormFull-amount"
                                                v-model="props.item.years[0].amount"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 1"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 1) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        1,
                                                        updateAmountsWhenPercentageChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                v-model="props.item.years[1].evolutionPercentage"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 1"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 1) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        1,
                                                        updateAllWhenAmountChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                data-cy="test9"
                                                v-model="props.item.years[1].amount"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 2"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 2) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        2,
                                                        updateAmountsWhenPercentageChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                data-cy="test10"
                                                v-model="props.item.years[2].evolutionPercentage"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 2"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 2) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        2,
                                                        updateAllWhenAmountChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                data-cy="test11"
                                                v-model="props.item.years[2].amount"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 3"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 3) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        3,
                                                        updateAmountsWhenPercentageChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                data-cy="test12"
                                                v-model="props.item.years[3].evolutionPercentage"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 3"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 3) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        3,
                                                        updateAllWhenAmountChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                v-model="props.item.years[3].amount"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 4"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 4) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        4,
                                                        updateAmountsWhenPercentageChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                v-model="props.item.years[4].evolutionPercentage"
                                            />
                                        </td>
                                        <td
                                            v-if="props.item.years.length > 4"
                                            class="pl-0 pr-1 py-0 ma-0"
                                        >
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                :disabled="
                                                    disableYearlyAmount(props.item, 4) &&
                                                    !props.item.activeReporting
                                                "
                                                @change="
                                                    modifyDetails(
                                                        props.item,
                                                        4,
                                                        updateAllWhenAmountChange,
                                                        buildActivityDefaultDetails,
                                                    )
                                                "
                                                v-model="props.item.years[4].amount"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                @change="buildActivityDefaultDetails(props.item)"
                                                data-cy="BudgetFormFull-testEvol"
                                                v-model="props.item.marginRate"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <v-select-filled
                                                v-model="props.item.paymentDelay"
                                                :items="paymentDelays"
                                                item-value="id"
                                                required
                                                hide-details="auto"
                                                density="compact"
                                                :item-title="(item) => item.name"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <oss-text-field-filled
                                                hide-details="auto"
                                                v-model="props.item.vatRate"
                                            />
                                        </td>
                                        <td class="pl-0 pr-1 py-0 ma-0">
                                            <v-select-filled
                                                v-model="props.item.vatCollectionTime"
                                                :items="vatCollectionTimes"
                                                item-value="id"
                                                required
                                                hide-details="auto"
                                                density="compact"
                                                :item-title="(item) => item.name"
                                            />
                                        </td>
                                        <td class="pl-2 pr-0 py-0 ma-0">
                                            <v-icon
                                                @click="props.toggleExpand(props.internalItem)"
                                                data-cy="BudgetFormFull-detail"
                                                v-tooltip:bottom="'Détail de la ligne'"
                                                >$oss-analysis</v-icon
                                            >
                                        </td>
                                        <td class="pl-0 ma-0">
                                            <v-tooltip location="bottom">
                                                <template v-slot:activator="{ props }">
                                                    <v-icon
                                                        @click="
                                                            activeItemType = 'activity';
                                                            deleteLine(props.index);
                                                        "
                                                        v-bind="props"
                                                        >$oss-trash</v-icon
                                                    >
                                                </template>
                                                <span>Supprimer la ligne </span>
                                            </v-tooltip>
                                            <v-tooltip location="bottom">
                                                <template v-slot:activator="{ props }">
                                                    <v-icon
                                                        @click="reinitializeLine(props.index)"
                                                        v-bind="props"
                                                        >$oss-file</v-icon
                                                    >
                                                </template>
                                                <span>Réinitialiser la ligne</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expanded-row="{ columns, item }">
                                    <td :colspan="columns.length">
                                        <ActivityDetails
                                            :activity="item"
                                            :parameters="parameters"
                                            :date="date"
                                            :isDetailEditable="!item.activeReporting"
                                            @store-active-details="onStoreActiveDetails($event)"
                                        />
                                    </td>
                                </template>
                                <template v-slot:[`body.append`]="{ columns }">
                                    <tr>
                                        <td :colspan="columns.length">
                                            <div class="d-flex justify-end mr-2">
                                                <v-btn
                                                    rounded
                                                    elevation="0"
                                                    @click="addActivity()"
                                                    size="small"
                                                >
                                                    Ajouter une ligne
                                                </v-btn>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>

                            <v-card-actions class="d-flex justify-center align-end">
                                <v-btn-prev @click="previous()" />
                                <v-btn-next @click="next()" />
                            </v-card-actions>
                        </v-card>
                    </v-window-item>
                    <!-- STEP 3 - CHARGES -->
                    <v-window-item value="3">
                        <v-card style="box-shadow: none">
                            <v-card-text stye="height:65vh;">
                                <!-- <v-row no-gutters>
                                    <h2>Charges</h2>
                                </v-row>
                                <v-spacer></v-spacer> -->
                                <v-expansion-panels v-model="chargesExpanded" multiple accordion>
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Charges fixes récurrentes</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="formBff.charges.recurringCharges"
                                                :headers="chargesHeaders"
                                                :itemsPerPage="
                                                    formBff.charges.recurringCharges.length
                                                "
                                                :single-expand="false"
                                                v-model:expanded="recurringChargesExpanded"
                                                item-key="title"
                                                show-expand
                                                hide-default-footer
                                                class="table"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <v-combobox-filled
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            :colspan="2"
                                                        >
                                                            <v-combobox-filled
                                                                v-model="props.item.title"
                                                                :items="recurringChargesItems"
                                                                dense
                                                                hide-details="auto"
                                                                data-cy="name"
                                                            />
                                                        </td>
                                                        <td class="pl-2 pr-0 py-0 ma-0">
                                                            <v-checkbox
                                                                v-model="props.item.activeReporting"
                                                                :ripple="false"
                                                                :disabled="
                                                                    !props.item.isLineReported
                                                                "
                                                                @update:model-value="
                                                                    onReportingChanged(props.item)
                                                                "
                                                            >
                                                            </v-checkbox>
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                disabled
                                                                v-model="props.item.amountNM1"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        0,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        false,
                                                                        updateAllWhenFirstYearChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="
                                                                    props.item.years[0]
                                                                        .evolutionPercentage
                                                                "
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        0,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        true,
                                                                        updateAllWhenFirstYearChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="props.item.years[0].amount"
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 1"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        1,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        1,
                                                                        updateAmountsWhenPercentageChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="
                                                                    props.item.years[1]
                                                                        .evolutionPercentage
                                                                "
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 1"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        1,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        1,
                                                                        updateAllWhenAmountChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="props.item.years[1].amount"
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 2"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        2,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        2,
                                                                        updateAmountsWhenPercentageChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="
                                                                    props.item.years[2]
                                                                        .evolutionPercentage
                                                                "
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 2"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        2,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        2,
                                                                        updateAllWhenAmountChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="props.item.years[2].amount"
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 3"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        3,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        3,
                                                                        updateAmountsWhenPercentageChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="
                                                                    props.item.years[3]
                                                                        .evolutionPercentage
                                                                "
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 3"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        3,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        3,
                                                                        updateAllWhenAmountChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="props.item.years[3].amount"
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 4"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        4,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        4,
                                                                        updateAmountsWhenPercentageChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="
                                                                    props.item.years[4]
                                                                        .evolutionPercentage
                                                                "
                                                            />
                                                        </td>
                                                        <td
                                                            v-if="props.item.years.length > 4"
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                        >
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :disabled="
                                                                    disableYearlyAmount(
                                                                        props.item,
                                                                        4,
                                                                    ) && !props.item.activeReporting
                                                                "
                                                                @change="
                                                                    modifyDetails(
                                                                        props.item,
                                                                        4,
                                                                        updateAllWhenAmountChange,
                                                                        buildChargeDefaultDetails,
                                                                    )
                                                                "
                                                                v-model="props.item.years[4].amount"
                                                            />
                                                        </td>
                                                        <!-- <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                class="oss-"
                                                                v-model.number="props.item.fixedPercentage"
                                                                type="number"


                                                                hide-details="auto"
                                                                :min="0"
                                                                :max="100"
                                                            ></oss-text-field-filled>
                                                        </td> -->
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.frequency"
                                                                :items="chargesFrequency"
                                                                item-value="id"
                                                                hide-details="auto"
                                                                :disabled="
                                                                    props.item.isLineReported
                                                                "
                                                                @update:model-value="
                                                                    fillSpecificDueDates(
                                                                        props.item,
                                                                        props.index,
                                                                    )
                                                                "
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="py-0 pl-0 pr-2 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.paymentDelay"
                                                                :items="paymentDelays"
                                                                item-value="id"
                                                                required
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                v-model="props.item.vatRate"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select-filled
                                                                v-model="
                                                                    props.item.vatCollectionTime
                                                                "
                                                                :items="vatCollectionTimes"
                                                                item-value="id"
                                                                required
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-2 pr-0 py-0 ma-0">
                                                            <v-icon
                                                                @click="
                                                                    props.toggleExpand(
                                                                        props.internalItem,
                                                                    )
                                                                "
                                                                :data-cy="
                                                                    'BudgetFormFull-analysis-' +
                                                                    props.index
                                                                "
                                                                v-tooltip:bottom="
                                                                    'Détail de la ligne'
                                                                "
                                                                >$oss-analysis</v-icon
                                                            >
                                                        </td>
                                                        <td class="pl-0 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType =
                                                                                'recurringCharge';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        :data-cy="
                                                                            'BudgetFormFull-trashEnd-' +
                                                                            props.index
                                                                        "
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:expanded-row="{ columns, item }">
                                                    <td :colspan="columns.length">
                                                        <ChargeDetails
                                                            :charge="item"
                                                            :parameters="parameters"
                                                            :date="date"
                                                            :isDetailEditable="
                                                                !item.activeReporting
                                                            "
                                                            @store-active-details="
                                                                onStoreActiveDetails($event)
                                                            "
                                                        />
                                                    </td>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div class="d-flex justify-end mr-2">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="addCharge()"
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                    <v-expansion-panel class="py-0 my-0">
                                        <v-expansion-panel-title class="py-0 my-0">
                                            <h3>Charges fixes uniques et immobilisations</h3>
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text class="py-0 my-0">
                                            <v-data-table
                                                :items="formBff.charges.uniqueCharges"
                                                :headers="investmentsHeaders"
                                                :itemsPerPage="formBff.charges.uniqueCharges.length"
                                                hide-default-footer
                                                class="table"
                                                density="compact"
                                            >
                                                <template v-slot:item="props">
                                                    <tr class="pa-0 ma-0" height="50">
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            v-if="selectedPartition"
                                                        >
                                                            <!-- <v-select
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                hide-details="auto"
                                                            ></v-select> -->
                                                            <v-combobox-filled
                                                                v-model="props.item.tag"
                                                                :items="tagsSelection"
                                                                item-value="id"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateTagsSelection(props.item)
                                                                "
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td
                                                            class="pl-0 pr-1 py-0 ma-0"
                                                            :colspan="2"
                                                        >
                                                            <v-combobox-filled
                                                                v-model="props.item.title"
                                                                :items="preSelectedExpenses"
                                                                dense
                                                                hide-details="auto"
                                                                @change="
                                                                    updateDefaultNature(props.item)
                                                                "
                                                            />
                                                        </td>
                                                        <!-- <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select
                                                                v-model="props.item.nature"
                                                                :items="investmentsNatures"


                                                                dense
                                                                class="oss-"
                                                                label="Nature"
                                                                hide-details="auto"
                                                            ></v-select>
                                                        </td> -->
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-date-picker-filled
                                                                :date="
                                                                    transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                "
                                                                @change-date="assignItemDate"
                                                                @close="
                                                                    transformDateToGap(props.item)
                                                                "
                                                                type="month"
                                                                format="MM-YYYY"
                                                                :text-field-readonly="false"
                                                                hide-details="auto"
                                                                density="compact"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                dense
                                                                v-model="props.item.amount"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-menu
                                                                :close-on-content-click="false"
                                                                offset-y
                                                                style="max-width: 500px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-btn v-bind="props"
                                                                        >Détail</v-btn
                                                                    >
                                                                </template>
                                                                <v-card
                                                                    class="pa-2 ma-2 elevation-0"
                                                                >
                                                                    <!-- <oss-text-field-filled
                                                                        v-model.number="props.item.budget[month].amountSigned"
                                                                        type="number"

                                                                        dense

                                                                        class="d-flex my-2 mr-2 float-left align-end oss-"
                                                                        hide-details="auto"
                                                                        @change="updateData(props.item, month)"
                                                                    ></oss-text-field-filled>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ props }">
                                                                            <v-icon
                                                                                right
                                                                                    size="small"
                                                                                class="d-flex mt-2"
                                                                                @click="duplicateRightAll(props.item, month)"
                                                                                v-on="{...tooltip}"
                                                                                >$oss-duplicate
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Dupliquer sur les cellules de droite</span>
                                                                    </v-tooltip> -->
                                                                    <v-row no-gutter>
                                                                        <v-col cols="5"
                                                                            >Type :
                                                                        </v-col>
                                                                        <v-col cols="7">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    props.item
                                                                                        .staggering
                                                                                "
                                                                                :items="
                                                                                    investmentStaggeringTypes
                                                                                "
                                                                                hide-details="auto"
                                                                                density="compact"
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row no-gutter>
                                                                        <v-col cols="5"
                                                                            >Différé :
                                                                        </v-col>
                                                                        <v-col cols="7">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    props.item
                                                                                        .staggeringOffset
                                                                                "
                                                                                :items="
                                                                                    offsetDelays
                                                                                "
                                                                                item-value="id"
                                                                                hide-details="auto"
                                                                                density="compact"
                                                                                :item-title="
                                                                                    (item) =>
                                                                                        item.name
                                                                                "
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row
                                                                        no-gutter
                                                                        v-if="
                                                                            props.item
                                                                                .staggering ===
                                                                            'Etalement'
                                                                        "
                                                                    >
                                                                        <v-col cols="5"
                                                                            >Durée :
                                                                        </v-col>
                                                                        <v-col cols="7">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                "
                                                                                :items="
                                                                                    staggeringDurationDelays
                                                                                "
                                                                                item-value="id"
                                                                                hide-details="auto"
                                                                                @update:model-value="
                                                                                    updateDefaultAmortizationLaw(
                                                                                        props.item,
                                                                                    )
                                                                                "
                                                                                density="compact"
                                                                                :item-title="
                                                                                    (item) =>
                                                                                        item.name
                                                                                "
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row
                                                                        no-gutter
                                                                        v-if="
                                                                            props.item
                                                                                .staggering ===
                                                                            'Amortissement'
                                                                        "
                                                                    >
                                                                        <v-col cols="5"
                                                                            >Durée :
                                                                        </v-col>
                                                                        <v-col cols="7">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                "
                                                                                :items="
                                                                                    durationDelays
                                                                                "
                                                                                item-value="id"
                                                                                hide-details="auto"
                                                                                @update:model-value="
                                                                                    updateDefaultAmortizationLaw(
                                                                                        props.item,
                                                                                    )
                                                                                "
                                                                                density="compact"
                                                                                :item-title="
                                                                                    (item) =>
                                                                                        item.name
                                                                                "
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row
                                                                        no-gutter
                                                                        v-if="
                                                                            props.item
                                                                                .staggering ===
                                                                            'Amortissement'
                                                                        "
                                                                    >
                                                                        <v-col cols="5"
                                                                            >Loi d'amortissement :
                                                                        </v-col>
                                                                        <v-col cols="7">
                                                                            <v-select-filled
                                                                                v-model="
                                                                                    props.item
                                                                                        .amortizationLaw
                                                                                "
                                                                                :items="
                                                                                    investmentsAmortizationLaws
                                                                                "
                                                                                item-value="id"
                                                                                hide-details="auto"
                                                                                density="compact"
                                                                                :item-title="
                                                                                    (item) =>
                                                                                        item.name
                                                                                "
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <!-- <v-tooltip bottom>
                                                                        <template v-slot:activator="{ props }">
                                                                            <v-icon
                                                                                right
                                                                                    size="small"
                                                                                class="d-flex mt-2"
                                                                                @click="props.item.displayStaggeringMenu=false"
                                                                                v-on="{...tooltip}"
                                                                                >$oss-circle-check
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Valider</span>
                                                                    </v-tooltip> -->
                                                                </v-card>
                                                            </v-menu>
                                                        </td>
                                                        <!-- <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select
                                                                v-model="props.item.staggering"
                                                                :items="investmentStaggeringTypes"


                                                                dense
                                                                class="oss- d-flex"
                                                                hide-details="auto"
                                                            ></v-select>
                                                            <v-select
                                                                v-model="props.item.staggeringOffset"
                                                                :items="offsetDelays"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss- d-flex"
                                                                label="Différé"
                                                                hide-details="auto"
                                                            ></v-select>
                                                            <v-select v-if="props.item.staggering !== 'Aucun'"
                                                                v-model="props.item.staggeringDuration"
                                                                :items="durationDelays"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                label="Durée"
                                                                hide-details="auto"
                                                                @change="updateDefaultAmortizationLaw(props.item)"
                                                            ></v-select>
                                                            <v-select v-if="props.item.staggering === 'Amortissement'"
                                                                v-model="props.item.amortizationLaw"
                                                                :items="investmentsAmortizationLaws"
                                                                item-text="name"
                                                                item-value="id"


                                                                dense
                                                                class="oss-"
                                                                label="Loi"
                                                                hide-details="auto"
                                                            ></v-select>
                                                        </td> -->
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                :min="1"
                                                                dense
                                                                v-model="props.item.paymentNumber"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <v-select-filled
                                                                v-model="props.item.paymentSpacing"
                                                                :items="uniqueChargePaymentSpacing"
                                                                item-value="id"
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-1 py-0 ma-0">
                                                            <oss-text-field-filled
                                                                hide-details="auto"
                                                                dense
                                                                v-model="props.item.vatRate"
                                                            />
                                                        </td>
                                                        <td class="pl-0 pr-0 py-0 ma-0">
                                                            <v-select-filled
                                                                v-model="
                                                                    props.item.vatCollectionTime
                                                                "
                                                                :items="vatCollectionTimes"
                                                                item-value="id"
                                                                hide-details="auto"
                                                                density="compact"
                                                                :item-title="(item) => item.name"
                                                            />
                                                        </td>
                                                        <td class="pl-2 ma-0">
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            activeItemType =
                                                                                'uniqueCharge';
                                                                            deleteLine(props.index);
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <span>Supprimer la ligne</span>
                                                            </v-tooltip>
                                                            <v-tooltip location="bottom">
                                                                <template
                                                                    v-slot:activator="{ props }"
                                                                >
                                                                    <v-icon
                                                                        @click="
                                                                            reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        "
                                                                        v-bind="props"
                                                                        >$oss-file</v-icon
                                                                    >
                                                                </template>
                                                                <span>Réinitialiser la ligne</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-slot:[`body.append`]="{ columns }">
                                                    <tr>
                                                        <td :colspan="columns.length">
                                                            <div
                                                                class="d-flex justify-end mt-1 mr-2"
                                                            >
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    @click="addInvestment()"
                                                                    size="small"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-center align-end">
                                <v-btn-prev @click="previous()" />
                                <v-btn-next @click="next()" />
                            </v-card-actions>
                        </v-card>
                    </v-window-item>
                    <!-- STEP 4 - STAFF -->
                    <v-window-item value="4">
                        <v-card style="box-shadow: none">
                            <v-card-text stye="height:65vh;">
                                <!-- <v-row no-gutters>
                                    <h2>Personnel</h2>
                                </v-row>
                                <v-spacer></v-spacer> -->
                                <v-data-table
                                    :items="formBff.staff"
                                    :headers="reactiveStaffHeaders"
                                    :itemsPerPage="formBff.staff.length"
                                    :single-expand="false"
                                    v-model:expanded="staffExpanded"
                                    item-key="title"
                                    show-expand
                                    hide-default-footer
                                    class="table"
                                >
                                    <template v-slot:item="props">
                                        <tr>
                                            <td
                                                class="pl-0 pr-1 py-0 ma-0"
                                                v-if="selectedPartition"
                                            >
                                                <!-- <v-select
                                                    v-model="props.item.tag"
                                                    :items="tagsSelection"
                                                    item-text="name"
                                                    item-value="id"


                                                    dense
                                                    class="oss-"
                                                    hide-details="auto"
                                                ></v-select> -->
                                                <v-combobox-filled
                                                    v-model="props.item.tag"
                                                    :items="tagsSelection"
                                                    item-value="id"
                                                    dense
                                                    hide-details="auto"
                                                    @change="updateTagsSelection(props.item)"
                                                    :item-title="(item) => item.name"
                                                />
                                            </td>
                                            <td class="pl-2 pr-0 py-0 ma-0">
                                                <v-checkbox
                                                    v-model="props.item.isBoss"
                                                    :ripple="false"
                                                    @update:model-value="reactiveStaffHeaders"
                                                >
                                                </v-checkbox>
                                            </td>
                                            <td class="pl-0 pr-1 py-0 ma-0" :colspan="2">
                                                <v-text-field-filled
                                                    v-model="props.item.title"
                                                    hide-details="auto"
                                                    data-cy="BudgetFormFull-libelle"
                                                    density="compact"
                                                />
                                            </td>
                                            <td class="pl-0 pr-1 py-0 ma-0">
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    @change="
                                                        updateFirstYearTotalGrossSalary(props.item);
                                                        buildStaffDefaultDetails(props.item);
                                                    "
                                                    data-cy="BudgetFormFull-effectif"
                                                    v-model="props.item.number"
                                                />
                                            </td>
                                            <td class="pl-0 pr-1 py-0 ma-0">
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    @change="
                                                        updateFirstYearTotalGrossSalary(props.item);
                                                        buildStaffDefaultDetails(props.item);
                                                    "
                                                    data-cy="BudgetFormFull-indifiduelAnnuelBrut"
                                                    v-model="props.item.years[0].individualAmount"
                                                />
                                            </td>
                                            <td class="pl-0 pr-1 py-0 ma-0">
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    @change="
                                                        updateFirstYearMonthlyGrossSalaryAndAmounts(
                                                            props.item,
                                                        );
                                                        buildStaffDefaultDetails(props.item);
                                                    "
                                                    disabled
                                                    v-model="props.item.years[0].totalAmount"
                                                />
                                            </td>
                                            <td
                                                v-if="props.item.years.length > 1"
                                                class="pl-0 pr-1 py-0 ma-0"
                                            >
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    @change="
                                                        updateStaffFurtherPercentages(props.item);
                                                        buildStaffDefaultDetails(props.item);
                                                    "
                                                    data-cy="BudgetFormFull-cotisationsSalarial"
                                                    v-model="
                                                        props.item.years[1].evolutionPercentage
                                                    "
                                                />
                                            </td>
                                            <td
                                                class="pl-0 pr-1 py-0 ma-0"
                                                v-if="!areAllSalariesBosses()"
                                            >
                                                <oss-text-field-filled
                                                    :disabled="props.item.isBoss"
                                                    hide-details="auto"
                                                    data-cy="BudgetFormFull-cotisationPatronales"
                                                    v-model="props.item.wagesTax"
                                                />
                                            </td>
                                            <td
                                                class="pl-0 pr-1 py-0 ma-0"
                                                v-if="!props.item.isBoss"
                                            >
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    data-cy="test4"
                                                    v-model="props.item.employerTax"
                                                />
                                            </td>
                                            <td
                                                class="pl-0 pr-1 py-0 ma-0"
                                                v-if="props.item.isBoss"
                                            >
                                                <oss-text-field-filled
                                                    hide-details="auto"
                                                    data-cy="test5"
                                                    v-model="props.item.globalTax"
                                                />
                                            </td>
                                            <td class="pl-2 pr-0 py-0 ma-0">
                                                <v-icon
                                                    @click="props.toggleExpand(props.internalItem)"
                                                    data-cy="BudgetFormFull-datail"
                                                    v-tooltip:bottom="'Détail de la ligne'"
                                                    >$oss-analysis</v-icon
                                                >
                                            </td>
                                            <td class="pl-2 ma-0">
                                                <v-tooltip location="bottom">
                                                    <template v-slot:activator="{ props }">
                                                        <v-icon
                                                            @click="
                                                                activeItemType = 'staff';
                                                                deleteLine(props.index);
                                                            "
                                                            v-bind="props"
                                                            >$oss-trash</v-icon
                                                        >
                                                    </template>
                                                    <span>Supprimer la ligne</span>
                                                </v-tooltip>
                                                <v-tooltip location="bottom">
                                                    <template v-slot:activator="{ props: tooltip }">
                                                        <v-icon
                                                            @click="reinitializeLine(props.index)"
                                                            v-bind="props"
                                                            >$oss-file</v-icon
                                                        >
                                                    </template>
                                                    <span>Réinitialiser la ligne</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:expanded-row="{ columns, item }">
                                        <td :colspan="columns.length">
                                            <StaffDetails
                                                :staff="item"
                                                :parameters="parameters"
                                                :date="date"
                                                @store-active-details="onStoreActiveDetails($event)"
                                            />
                                        </td>
                                    </template>
                                    <template v-slot:[`body.append`]="{ columns }">
                                        <tr>
                                            <td :colspan="columns.length">
                                                <div class="d-flex justify-end mr-2">
                                                    <v-btn
                                                        rounded
                                                        elevation="0"
                                                        @click="addStaff()"
                                                        size="small"
                                                    >
                                                        Ajouter une ligne
                                                    </v-btn>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-center align-end">
                                <v-btn-prev @click="previous()" />
                                <v-btn-next @click="next()" />
                            </v-card-actions>
                        </v-card>
                    </v-window-item>
                </v-tabs-window>
            </div>
        </v-card>
        <v-snackbar v-model="displayFillingOptions" :timeout="timeout" color="primary">
            Voulez-vous reporter la valeur que vous venez de saisir jusqu'à la fin de l'exercice ?
            <template v-slot:actions>
                <v-btn @click="onValueReported" variant="text"> Reporter </v-btn>
            </template>
        </v-snackbar>
        <oss-dialog
            v-model="displayStaggeringDialog"
            @valid="validStaggering"
            @close="closeStaggering"
            validTitle="Reporter la valeur"
            :valid-loading="staggeringLoading"
            :minWidth="width"
            :height="height"
            min-height="80vh"
            :valid-disabled="!finalStepCompletedStaggering"
        >
            <v-card>
                <v-card-title>
                    {{ stepTitle }}
                </v-card-title>
                <v-window
                    v-model="staggeringStep"
                    touchless
                    class="elevation-0"
                    style="background: transparent"
                >
                    <v-window-item :value="1">
                        <v-card-text class="py-0">
                            <v-list subheader lines="two">
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringModification = 'equal';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant à l'identique</v-list-item-title
                                    ><v-list-item-subtitle
                                        >Toutes les cases situées dans la période de report
                                        porteront la même valeur</v-list-item-subtitle
                                    ></v-list-item
                                >
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringModification = 'percentage';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant en lui appliquant un
                                        pourcentage</v-list-item-title
                                    ><v-list-item-subtitle
                                        >Un pourcentage est appliqué au montant à reporter tous les
                                        x mois.</v-list-item-subtitle
                                    ></v-list-item
                                >
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringModification = 'amount';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant en lui ajoutant ou soustrayant un
                                        montant</v-list-item-title
                                    ><v-list-item-subtitle
                                        >Cette addition ou soustraction est appliquée au montant à
                                        reporter tous les x mois.</v-list-item-subtitle
                                    ></v-list-item
                                >
                            </v-list>
                        </v-card-text>
                    </v-window-item>
                    <v-window-item :value="2">
                        <v-card-text class="py-0">
                            <v-list subheader lines="two">
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringPeriod = 'exercise';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant jusqu'à la fin de l'exercice
                                        sélectionné</v-list-item-title
                                    ><v-list-item-subtitle
                                        >Aucun autre exercice ne sera modifié.</v-list-item-subtitle
                                    ></v-list-item
                                >
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringPeriod = 'budget';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant jusqu'à la fin du
                                        budget</v-list-item-title
                                    ><v-list-item-subtitle
                                        >La modification sera appliquée sur l'exercice sélectionné
                                        et tous les exercices qui lui sont
                                        postérieurs.</v-list-item-subtitle
                                    ></v-list-item
                                >
                                <v-list-item
                                    class="mb-2 rounded-lg"
                                    @click="
                                        staggeringPeriod = 'custom';
                                        staggeringStep++;
                                    "
                                >
                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                    <v-list-item-title
                                        >Reporter le montant jusqu'à une date
                                        précise</v-list-item-title
                                    ><v-list-item-subtitle
                                        >La modification sera appliquée sur tous les mois situé
                                        entre le mois modifié et la date de fin de report
                                        choisie.</v-list-item-subtitle
                                    ></v-list-item
                                >
                            </v-list>
                        </v-card-text>
                    </v-window-item>
                    <v-window-item :value="3">
                        <v-card-text class="py-0">
                            <v-row no-gutters>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringPeriod === 'custom'"
                                >
                                    <h4>Sélection de la date de fin de report :</h4>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringPeriod === 'custom'"
                                >
                                    <oss-date-picker-filled
                                        v-model="staggeringEndDate"
                                        type="month"
                                        format="MM-YYYY"
                                        :text-field-readonly="false"
                                        hide-details="auto"
                                    >
                                    </oss-date-picker-filled>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringModification !== 'equal'"
                                >
                                    <h4>Sélection du montant de la modification à appliquer :</h4>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringModification !== 'equal'"
                                >
                                    <oss-text-field-filled
                                        label="%"
                                        hide-details="auto"
                                        v-if="staggeringModification === 'percentage'"
                                        v-model="staggeringPercentage"
                                    />
                                    <oss-text-field-filled
                                        label="&#x20ac;"
                                        hide-details="auto"
                                        v-else-if="staggeringModification === 'amount'"
                                        v-model="staggeringAmount"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringModification !== 'equal'"
                                >
                                    <h4>
                                        Sélection du délai entre 2 applications de la modification
                                    </h4>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="d-flex mb-2"
                                    v-if="staggeringModification !== 'equal'"
                                >
                                    <v-select-filled
                                        v-model="staggeringModificationFrequency"
                                        :items="staggeringModificationFrequencies"
                                        item-value="id"
                                        required
                                        label="Temps que met le client à vous payer"
                                        hide-details="auto"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-window-item>
                </v-window>
            </v-card>
        </oss-dialog>
    </v-form>
</template>

<script lang="ts">
import ActivityDetails from "./ActivityDetails.vue";
import ChargeDetails from "./ChargeDetails.vue";
import StaffDetails from "./StaffDetails.vue";
import moment from "moment-timezone";

import CREATE_TAG from "../../graphql/tag/CreateTag.gql";
import {
    buildActivityYearlyDetailsItems,
    buildChargeYearlyDetailsItems,
    buildStaffYearlyDetailsItems,
    getOrderedMonthsFirstPeriod,
    getOrderedMonthsPeriods,
} from "../../services/budgetFormFullDetails";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch, Emit } from "vue-facing-decorator";

@Component({
    components: {
        ActivityDetails,
        ChargeDetails,
        StaffDetails,
        // TagsManager,
    },
    emits: ["validation-update"],
})
export class BudgetFormFull extends Vue {
    // @Prop({ default: "false" }) value: boolean;
    // @Prop({ default: null }) formBfaa: any;
    // @Prop({ default: "" }) selectedBfaaEndDate: string;
    @Prop({ default: null }) formBff: any;
    @Prop({ default: "AA" }) groupingMode: string;
    @Prop({ default: moment().startOf("month").format() }) date: string;
    @Prop({ default: null }) parameters: any;
    @Prop({ default: [] }) availableSalesAccounts: Array<any>;
    @Prop({ default: [] }) partitionTags: Array<any>;
    @Prop({ default: "" }) selectedPartition: string;
    @Prop({ default: null }) initializationPackage: any;
    @Prop({ default: null }) headersPackage: any;
    @Prop({ default: null }) selectedCompany: any;
    // @Prop({ default: null }) refreshHeadersOnPartitionChanged: number;

    // props

    // props for web
    width = "100%";
    height = "95%";
    step: string = "1";
    fundingsExpanded = [0];
    activitiesExpanded: any = [];
    chargesExpanded = [0, 1];
    activeItemType: String = null;
    recurringChargesExpanded: any = [];
    staffExpanded: any = [];
    // date = moment().startOf('month').format();
    dateToAssign = null;
    tagsCreationCounter = 0;
    defaultTag = null;
    // skipTagQuery = false;
    // skipBudgetQuery = true;
    // validLoading = false;
    shortHeaders: boolean = false;
    // displayPartitionSelection = true;
    displayTagManager = false;
    instantiated = false;
    isTagManagerClosing = false;
    relatedBfaaId: string = "";
    // partitionTags = [];

    validForm: boolean = true;

    blankCapitalContribution: any = null;
    blankCurrentAccountContribution: any = null;
    blankLoan: any = null;
    blankInvestmentGrant: any = null;
    blankActivity: any = null;
    blankCharge: any = null;
    blankInvestment: any = null;
    blankStaff: any = null;

    activitiesHeaders: Array<any> = [];
    chargesHeaders: Array<any> = [];

    displayFillingOptions: boolean = false;
    timeout: number = 6000;
    pathToActiveObject: any = {
        item: undefined,
        itemType: undefined,
        yearIndex: undefined,
        monthIndex: undefined,
        valueToReport: undefined,
    };

    displayStaggeringDialog: boolean = false;
    staggeringLoading: boolean = false;
    staggeringStep: number = 1;
    staggeringPeriod: string = "exercise"; // exercise, budget, custom
    staggeringModification: string = "equal"; // equal, percentage, amount
    staggeringEndDate: string = moment().format(); // used if period is custom
    staggeringPercentage: number = 0; // used if modification is percentage
    staggeringAmount: number = 0; // used if modification is amount
    staggeringModificationFrequency: number = -1; // used if modification is percentage or amount

    staggeringModificationFrequencies = [
        { id: -1, name: "Une seule fois" },
        { id: 0, name: "Au début de chaque exercice" },
        { id: 1, name: "Tous les mois" },
        { id: 2, name: "Tous les 2 mois" },
        { id: 3, name: "Tous les 3 mois" },
        { id: 4, name: "Tous les 4 mois" },
        { id: 6, name: "Tous les 6 mois" },
        { id: 9, name: "Tous les 9 mois" },
        { id: 12, name: "Tous les 12 mois" },
    ];

    get finalStepCompletedStaggering() {
        return this.staggeringStep === 3;
    }

    get stepTitle() {
        if (this.staggeringStep === 1) {
            return "Ajustement du montant à reporter";
        } else if (this.staggeringStep === 2) {
            return "Étendue du report";
        } else {
            return "Finalisation du report";
        }
    }

    get tagsSelection() {
        let tags = [];
        for (const partition of this.partitionTags) {
            if (this.selectedPartition === partition.id) {
                tags = partition.tags;
                break;
            }
        }
        return tags;
    }

    // get selectedPartition() {
    //     let selectedPartition = null;
    //     if (this.partitionTags.length === 0) {
    //         this.shortenHeaders();
    //     }
    //     return selectedPartition;
    // }

    // set selectedPartition(newValue) {
    //     if (this.partitionTags.length > 0) {
    //         this.lengthenHeaders();
    //     }
    // }

    shortenHeaders() {
        if (!this.shortHeaders && !this.selectedPartition) {
            this.capitalContributionsHeaders.splice(0, 1);
            this.currentAccountContributionsHeaders.splice(0, 1);
            this.loansHeaders.splice(0, 1);
            this.investmentGrantHeaders.splice(0, 1);
            this.activitiesHeaders.splice(0, 1);
            this.chargesHeaders.splice(0, 1);
            this.investmentsHeaders.splice(0, 1);
            this.staffHeaders.splice(0, 1);
            this.staffHeadersBosses.splice(0, 1);
            this.shortHeaders = true;
        }
    }

    lengthenHeaders() {
        if (this.shortHeaders && this.selectedPartition) {
            const newLine = { title: "Étiquette", value: "tag" };
            this.capitalContributionsHeaders.splice(0, 0, newLine);
            this.currentAccountContributionsHeaders.splice(0, 0, newLine);
            this.loansHeaders.splice(0, 0, newLine);
            this.investmentGrantHeaders.splice(0, 0, newLine);
            this.activitiesHeaders.splice(0, 0, newLine);
            this.chargesHeaders.splice(0, 0, newLine);
            this.investmentsHeaders.splice(0, 0, newLine);
            this.staffHeaders.splice(0, 0, newLine);
            this.shortHeaders = false;
        }
    }

    // onDateChanged() {
    //     this.buildActivitiesDefaultDetails();
    //     this.buildChargesDefaultDetails();
    //     this.buildStaffsDefaultDetails();
    // }
    @Emit("validation-update")
    @Watch("validForm")
    onValidFormChanged() {
        return this.validForm; // this.$emit("validation-update", this.validForm);
    }

    @Watch("headersPackage")
    onHeadersPackageChanged() {
        this.unpackHeadersPackage();
    }

    // @Watch("refreshHeadersOnPartitionChanged")
    // onRefreshHeaders() {
    //     if (this.selectedPartition) {
    //         this.lengthenHeaders()
    //     } else {
    //         this.shortenHeaders()
    //     }
    // }

    //props for TS

    // newBudgetId: string = "";
    // budgetName: string = "Nouveau scénario (full)";

    // budgetModified = false;
    // budgetDateModified = false;
    // budgetNameModified = false;
    // budgetFormModified = true;

    skip: boolean = false;

    // items, headers

    paymentDelays = [
        { id: 0, name: "0 jours" },
        { id: 1, name: "30 jours" },
        { id: 2, name: "60 jours" },
        { id: 3, name: "90 jours" },
        { id: 4, name: "120 jours" },
        { id: 5, name: "150 jours" },
        { id: 6, name: "180 jours" },
    ];

    preSelectedExpenses = [
        "Frais d'établissement",
        "Frais d'ouverture de compteurs",
        "Logiciels, formations",
        "Dépôt de marques, brevet, modèle", // Intellectual Property ?
        "Droits d'entrée",
        "Achat fonds de commerce ou parts",
        "Droit au bail",
        "Caution ou dépôt de garantie",
        "Frais de dossier",
        "Frais de notaire ou d'avocat",
        "Enseigne et élements de communication",
        "Achat immobilier",
        "Travaux et aménagements",
        "Matériel",
        "Matériel de bureau",
    ];

    correspondingNatures = [
        { id: "Frais d'établissement", nature: "Incorporel" },
        { id: "Frais d'ouverture de compteurs", nature: "Corporel" },
        { id: "Logiciels, formations", nature: "Incorporel" },
        { id: "Dépôt de marques, brevet, modèle", nature: "Incorporel" }, // Intellectual Property ?
        { id: "Droits d'entrée", nature: "Incorporel" },
        { id: "Achat fonds de commerce ou parts", nature: "Incorporel" },
        { id: "Droit au bail", nature: "Incorporel" },
        { id: "Caution ou dépôt de garantie", nature: "Incorporel" },
        { id: "Frais de dossier", nature: "Incorporel" },
        { id: "Frais de notaire ou d'avocat", nature: "Incorporel" },
        { id: "Enseigne et élements de communication", nature: "Corporel" },
        { id: "Achat immobilier", nature: "Corporel" },
        { id: "Travaux et aménagements", nature: "Corporel" },
        { id: "Matériel", nature: "Corporel" },
        { id: "Matériel de bureau", nature: "Corporel" },
    ];

    investmentsHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Libellé", value: "title" },
        { title: "", value: "" },
        { title: "Date", value: "date" },
        { title: "Montant", value: "amount" },
        { title: "Détail", value: "staggering" },
        { title: "Nombre de paiements", value: "paymentNumber" },
        { title: "Espacement", value: "paymentSpacing" },
        { title: "TVA", value: "vatRate" },
        { title: "Collecte", value: "vatCollectionTime" },
        { title: "Actions", value: "action" },
    ];

    investmentsNatures = ["Corporel", "Incorporel"];

    investmentsAmortizationLaws = ["Aucun", "Linéaire", "Dégressif"];

    investmentStaggeringTypes = ["Aucun", "Etalement", "Amortissement"];

    offsetDelays = [
        { id: 0, name: "0 mois" },
        { id: 1, name: "1 mois" },
        { id: 2, name: "2 mois" },
        { id: 3, name: "3 mois" },
        { id: 6, name: "6 mois" },
        { id: 12, name: "12 mois" },
    ];

    durationDelays = [
        { id: 12, name: "1 an" },
        { id: 24, name: "2 ans" },
        { id: 36, name: "3 ans" },
        { id: 48, name: "4 ans" },
        { id: 60, name: "5 ans" },
        { id: 72, name: "6 ans" },
        { id: 84, name: "7 ans" },
        { id: 96, name: "8 ans" },
        { id: 108, name: "9 ans" },
        { id: 120, name: "10 ans" },
        { id: 144, name: "12 ans" },
        { id: 180, name: "15 ans" },
        { id: 240, name: "20 ans" },
        { id: 300, name: "25 ans" },
    ];

    vatCollectionTimes = ["Au décaissement", "A la facturation"];

    capitalContributionsHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Libellé", value: "title" },
        { title: "Date", value: "date" },
        { title: "Montant", value: "amount" },
        { title: "Actions", value: "action" },
    ];

    currentAccountContributionsHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Nom", value: "name" },
        { title: "Date", value: "date" },
        { title: "Montant", value: "amount" },
        { title: "Actions", value: "action" },
    ];

    loansHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Libellé", value: "title" },
        { title: "", value: "" },
        { title: "Date", value: "date" },
        { title: "Montant", value: "amount" },
        { title: "Taux", value: "rate" },
        { title: "Durée", value: "duration" },
        { title: "Périodicité", value: "periodicity" },
        { title: "Assurance", value: "insuranceRate" },
        { title: "Échéance", value: "" },
        { title: "Coût total", value: "" },
        { title: "Actions", value: "action" },
    ];

    investmentGrantHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Libellé", value: "title" },
        { title: "Date", value: "date" },
        { title: "Montant", value: "amount" },
        { title: "Amortissement", value: "amortizationLaw" },
        { title: "Durée", value: "amortizationDuration" },
        { title: "Actions", value: "action" },
    ];

    loanPeriodicity = [
        { id: 12, name: "Mensuelle" },
        { id: 6, name: "Bimestrielle" },
        { id: 4, name: "Trimestrielle" },
        { id: 2, name: "Semestrielle" },
        { id: 1, name: "Annuelle" },
        { id: 0, name: "Franchise totale" },
    ];

    // activitiesSectors = ["Négoce", "Production", "Services"]

    // availableSalesAccounts = [ // initialization as null doesn't change anything
    //     // { name: "701", description: "Ventes de produits finis" },
    //     // { name: "702", description: "Ventes de produits intermédiaires" },
    //     // { name: "704", description: "Travaux" },
    //     // { name: "705", description: "Études" },
    //     // { name: "706", description: "Prestations de services" },
    //     // { name: "707", description: "Ventes de marchandises" },
    //     // { name: "708", description: "Produits des activités annexes" },
    //     // { name: "709", description: "Rabais, remises et ristournes accordés par l'entreprise" }
    // ];

    // get activitiesSalesAccounts() {
    //     if (this.selectedCompany.salesAccounts && this.selectedCompany.salesAccounts.length > 0) {
    //         return this.selectedCompany.salesAccounts;
    //     } else {
    //         return this.availableSalesAccounts;
    //     }
    // }

    chargesFrequency = [
        { id: 12, name: "Mensuelle" },
        { id: 6, name: "Bimestrielle" },
        { id: 4, name: "Trimestrielle" },
        { id: 2, name: "Semestrielle" },
        { id: 1, name: "Annuelle" },
    ];

    monthsOfWagesPayment = ["Mois en cours", "Mois suivant"];

    staffHeaders = [
        { title: "Étiquette", value: "tag" },
        { title: "Dirigeant", value: "isBoss" },
        { title: "Libellé", value: "title" },
        { title: "", value: "" },
        { title: "Effectif", value: "number" },
        { title: "Individuel annuel brut", value: "years[0].individualAmount" },
        { title: "Global annuel brut", value: "years[0].totalAmount" },
        { title: "% augmentation annuel", value: "years[1].evolutionPercentage" },
        { title: "Cotisations salariales", value: "wagesTax" },
        { title: "Cotisations patronales", value: "employerTax" },
        { title: "Détails", value: "data-table-expand" },
        { title: "Actions", value: "" },
    ];

    staffHeadersBosses = [
        { title: "Étiquette", value: "tag" },
        { title: "Dirigeant", value: "isBoss" },
        { title: "Libellé", value: "title" },
        { title: "", value: "" },
        { title: "Effectif", value: "number" },
        { title: "Individuel annuel brut", value: "years[0].individualAmount" },
        { title: "Global annuel brut", value: "years[0].totalAmount" },
        { title: "% augmentation annuel", value: "years[1].evolutionPercentage" },
        { title: "Cotisations sociales", value: "globalTax" },
        { title: "Détails", value: "data-table-expand" },
        { title: "Actions", value: "" },
    ];

    get reactiveStaffHeaders() {
        const bosses = JSON.parse(JSON.stringify(this.staffHeadersBosses));
        const normal = JSON.parse(JSON.stringify(this.staffHeaders));
        if (this.parameters.periodsNumber === 1) {
            const insertionIndex = this.shortHeaders ? 6 : 7;
            bosses.splice(insertionIndex, 1);
            normal.splice(insertionIndex, 1);
        }
        if (this.areAllSalariesBosses()) {
            return bosses;
        } else {
            return normal;
        }
    }

    uniqueChargePaymentSpacing = [
        { id: 1, name: "1 mois" },
        { id: 2, name: "2 mois" },
        { id: 3, name: "3 mois" },
        { id: 4, name: "4 mois" },
        { id: 6, name: "6 mois" },
        { id: 9, name: "9 mois" },
        { id: 12, name: "12 mois" },
    ];

    staggeringDurationDelays = [
        { id: 2, name: "2 mois" },
        { id: 3, name: "3 mois" },
        { id: 4, name: "4 mois" },
        { id: 6, name: "6 mois" },
        { id: 9, name: "9 mois" },
        { id: 12, name: "12 mois" },
        { id: 15, name: "15 mois" },
        { id: 18, name: "18 mois" },
        { id: 24, name: "24 mois" },
        { id: 36, name: "36 mois" },
    ];

    recurringChargesItems = [
        "Assurances",
        "Téléphone, internet",
        "Autres abonnements",
        "Carburant, transports",
        "Frais de déplacement et hébergement",
        "Eau, électricité, gaz",
        "Fournitures diverses",
        "Entretien de matériel",
        "Nettoyage des locaux",
        "Budget publicité et communication",
        "Loyer et charges locatives",
        "Expert comptable, avocats",
        "Frais bancaires et terminal de paiement",
        "Taxes, CFE",
    ];

    bossPaymentModes = [
        { id: "BP", name: "Budget Primitif" },
        { id: "TNS", name: "Traitement Non Salarié" },
    ];

    // data storage variables

    // formBff : any = {
    //     fundings: {
    //         capitalContributions: [],
    //         currentAccountContributions: [],
    //         loans: [],
    //         investmentGrants: []
    //     },
    //     activities: [],
    //     charges: {
    //         recurringCharges: [],
    //         uniqueCharges: []
    //     },
    //     staff: []
    // };

    async previous() {
        // this.loadingPrevious = true;
        // await this.save();
        let index = parseFloat(this.step);
        index -= 1;
        this.step = index.toString();
        // this.loadingPrevious = false;
    }

    async next() {
        // this.loadingNext = true;
        // await this.save();
        let index = parseFloat(this.step);
        index += 1;
        this.step = index.toString();
        // this.loadingNext = false;
    }

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    beforeMount() {
        this.unpackInitializationPackage();
        this.unpackHeadersPackage();
        // this.buildActivitiesYears();
        // this.buildChargesYears();
        // this.buildStaffYears();
        this.shortenHeaders();
        this.checkFirstYearEvolutionPercentage();
    }

    // transformTags() {
    //     // GQL mutation to create the missing ids for manually created tags
    //     // for (const partitionTag of this.partitionTags) {
    //     //     for (const tag of partitionTag.tags) {
    //     //         if (tag.id.substring(0,3) === "new") {
    //     //             const result = await this.$apollo.mutate({
    //     //                 mutation: CREATE_TAG,
    //     //                 variables: {
    //     //                     name: tag.name,
    //     //                     companyId: this.selectedCompany.id,
    //     //                     partitionConnect: {connect: { id: partitionTag.id } }
    //     //                 }
    //     //             });
    //     //             if (result && result.data && result.data.createTag && result.data.createTag.id) {
    //     //                 tag.id = result.data.createTag.id;
    //     //             }
    //     //         }
    //     //     }
    //     // }
    //     // transforming tag object into tag ids for storage
    //     this.tagsMutationToIds();
    // }

    addInvestment() {
        this.formBff.charges.uniqueCharges.push(JSON.parse(JSON.stringify(this.blankInvestment)));
    }

    updateDefaultNature(item) {
        for (const expense of this.correspondingNatures) {
            if (expense.id === item.title) {
                item.nature = expense.nature;
            }
        }
    }

    updateDefaultAmortizationLaw(item) {
        if (item.staggering === "Amortissement") {
            if (item.staggeringDuration < 3) {
                item.amortizationLaw = "Linéaire";
            } else {
                item.amortizationLaw = "Dégressif";
            }
        } else if (item.staggering === "Etalement") {
            item.amortizationLaw = "Linéaire";
        } else {
            item.amortizationLaw = "Aucun";
        }
    }

    addCapitalContribution() {
        this.formBff.fundings.capitalContributions.push(
            JSON.parse(JSON.stringify(this.blankCapitalContribution)),
        );
    }

    addCurrentAccountContribution() {
        this.formBff.fundings.currentAccountContributions.push(
            JSON.parse(JSON.stringify(this.blankCurrentAccountContribution)),
        );
    }

    addLoan() {
        this.formBff.fundings.loans.push(JSON.parse(JSON.stringify(this.blankLoan)));
    }

    loanMonthlyAmount(item, rate, insuranceMonthlyAmount) {
        // computation of monthly amount given total amount, duration and rate
        const totalAmount = item.amount; // amount loaned by bank
        const coefficient = rate / 100; // yearly interests or cumulative rate
        const periodicity = item.periodicity > 0 ? item.periodicity : 1 / item.duration; // number of payments per year
        const monthsNumber = item.duration;
        const geometricCoefficient = 1 + coefficient / periodicity;
        let poweredCoefficient = 1;
        for (let power = 0; power < monthsNumber; power++) {
            poweredCoefficient /= geometricCoefficient;
        }
        let denominator = 1 - poweredCoefficient;
        let nominator = (totalAmount * coefficient) / periodicity;
        const monthlyAmount = this.round(nominator / denominator + insuranceMonthlyAmount, 1);
        item.monthlyAmount = monthlyAmount;
        return monthlyAmount;
    }

    loanTotalCost(item) {
        const periodicity = item.periodicity > 0 ? item.periodicity : 1 / item.duration;
        const totalCost = item.monthlyAmount * item.duration - item.amount;
        item.totalCost = totalCost;
        return this.round(totalCost, 1);
    }

    computeLoanAmounts(item) {
        // item.details = {
        //     accountingLines: [], // paymentDates in the time window of the previsional budget
        //     amounts: [], // all paymentDates regardless the membership to the previsional budget time window
        // };
        // let leftDueAmount = item.amount;
        const periodicity = item.periodicity > 0 ? item.periodicity : 1 / item.duration; // number of payments per year
        if (this.parameters.loanInsuranceMode === "CE") {
            // if the insurance amout is based on the loaned amount
            const insurance = (item.amount * item.insuranceRate) / 100 / periodicity;
            const monthlyAmount = this.loanMonthlyAmount(item, item.rate, insurance);
            // insuranceTotal = insurance * periodicity * item.duration;
            // for (let month = moment(item.date); month.isBefore(endOfLoan); month.add(12/periodicity, 'months')) {
            //     const interest = leftDueAmount * item.rate / 100 / periodicity;
            //     const refunding = monthlyAmount - interest - insurance;
            //     leftDueAmount -= refunding;
            //     interestTotal += interest;
            //     insuranceTotal2 += insurance;
            //     const accountingLine = {
            //         date: month.format("YYYY-MM-DD"),
            //         interest : interest,
            //         refunding: refunding,
            //         insurance: insurance
            //     };
            //     if (month.isBefore(shortestDate)) {
            //         item.details.accountingLines.push(accountingLine);
            //     }
            //     item.details.amounts.push(accountingLine);
            // }
        } else {
            // if the insurance amount is based on the left amount to refund
            const cumulativeRate = item.rate + item.insuranceRate;
            const monthlyAmount = this.loanMonthlyAmount(item, cumulativeRate, 0);
            // for (let month = moment(item.date); month.isBefore(endOfLoan); month.add(12/periodicity, 'months')) {
            //     const interest = leftDueAmount * item.rate / 100 / periodicity;
            //     const insurance = leftDueAmount * item.insuranceRate / 100 / periodicity;
            //     const refunding = monthlyAmount - interest - insurance;
            //     leftDueAmount -= refunding;
            //     interestTotal += interest;
            //     insuranceTotal += insurance;
            //     const accountingLine = {
            //         date: month.format("YYYY-MM-DD"),
            //         interest : interest,
            //         refunding: refunding,
            //         insurance: insurance
            //     };
            //     if (month.isBefore(shortestDate)) {
            //         item.details.accountingLines.push(accountingLine);
            //     }
            //     item.details.amounts.push(accountingLine);
            // }
        }
        this.loanTotalCost(item);
        // return item.details;
    }

    addInvestmentGrant() {
        this.formBff.fundings.investmentGrants.push(
            JSON.parse(JSON.stringify(this.blankInvestmentGrant)),
        );
    }

    updateAmountsWhenPercentageChange(item, startIndex) {
        const yearsLength = item.years.length;
        for (let yearIndex = startIndex; yearIndex < yearsLength; yearIndex++) {
            let year = item.years[yearIndex];
            if (this.disableYearlyAmount(item, yearIndex) && !item.activeReporting) {
                year.evolutionPercentage = (
                    100 *
                    (year.amount / item.years[yearIndex - 1].amount - 1)
                ).toFixed(1);
                break;
            }
            year.amount = (
                item.years[yearIndex - 1].amount *
                (1 + year.evolutionPercentage / 100)
            ).toFixed(0);
        }
    }

    updateAllWhenAmountChange(item, yearIndex) {
        let year = item.years[yearIndex];
        year.evolutionPercentage = (
            100 *
            (year.amount / item.years[yearIndex - 1].amount - 1)
        ).toFixed(1);
        this.updateAmountsWhenPercentageChange(item, yearIndex + 1);
    }

    buildActivityDefaultDetails(item) {
        let details = [];
        const previousDetails = JSON.parse(JSON.stringify(item.details));
        for (let yearIndex = 0; yearIndex < 5; yearIndex++) {
            let detailsYear = [];
            const yearlyPreviousDetails = previousDetails[yearIndex];
            detailsYear = buildActivityYearlyDetailsItems(
                item,
                yearIndex,
                yearlyPreviousDetails,
                this.parameters,
                this.date,
            );
            details.push(detailsYear);
        }
        item.details = details;
    }

    addActivity() {
        this.formBff.activities.push(JSON.parse(JSON.stringify(this.blankActivity)));
    }

    addCharge() {
        this.formBff.charges.recurringCharges.push(JSON.parse(JSON.stringify(this.blankCharge)));
    }

    buildChargeDefaultDetails(item) {
        let details = [];
        const previousDetails = JSON.parse(JSON.stringify(item.details));
        for (let yearIndex = 0; yearIndex < 5; yearIndex++) {
            let detailsYear = [];
            const yearlyPreviousDetails =
                previousDetails && previousDetails.length > yearIndex
                    ? previousDetails[yearIndex]
                    : null;
            detailsYear = buildChargeYearlyDetailsItems(
                item,
                yearIndex,
                yearlyPreviousDetails,
                this.parameters,
                this.date,
            );
            details.push(detailsYear);
        }
        item.details = details;
    }

    fillSpecificDueDates(charge, chargeIndex) {
        let details = [];
        const paymentsNumber = charge.frequency;
        const paymentsSpacing = 12 / charge.frequency;
        const amountPercentage = 100 / paymentsNumber;
        this.resetDetails(charge); // if user pick a different frequency than monthly we erase all the amounts he previously wrote
        for (let yearIndex = 0; yearIndex < 5; yearIndex++) {
            const yearlyDetails = JSON.parse(JSON.stringify(charge.details[yearIndex]));
            if (yearlyDetails.length > 0) {
                let counter = paymentsSpacing;
                for (let monthIndex = 0; monthIndex < 12; monthIndex += 1) {
                    if (counter === paymentsSpacing) {
                        yearlyDetails[1].months[monthIndex].amount = amountPercentage; // modifying percentages is enough because build function automatically creates the corresponding amounts
                        this.markEditedValues(yearlyDetails, monthIndex); // important to mark the edition, else the modification will not be taken into account by build function
                        counter = 0;
                    }
                    // else {
                    //     yearlyDetails[1].months[monthIndex].amount = 0;
                    //     // this.markEditedValues(yearlyDetails, monthIndex);
                    // }
                    counter += 1;
                }
            }
            const modifiedYearlyDetails = buildChargeYearlyDetailsItems(
                charge,
                yearIndex,
                yearlyDetails,
                this.parameters,
                this.date,
            );
            details.push(modifiedYearlyDetails);
        }
        charge.details = details;
        // this.formBff.charges.recurringCharges[chargeIndex].details = details;
    }

    markEditedValues(yearlyDetails, monthIndex) {
        // this function only works for charges frequency modifications because it sets manually modified to the 2nd (index 1) line's amount
        for (let lineIndex = 0; lineIndex < yearlyDetails.length; lineIndex++) {
            yearlyDetails[lineIndex].months[monthIndex].edited = true;
            yearlyDetails[lineIndex].months[monthIndex].manuallyModified = lineIndex === 1;
            yearlyDetails[lineIndex].uneditedCount -= 1;
        }
    }

    resetDetails(charge) {
        charge.details = [];
        for (let yearIndex = 0; yearIndex < 5; yearIndex++) {
            const yearlyDetails = buildChargeYearlyDetailsItems(
                charge,
                yearIndex,
                null,
                this.parameters,
                this.date,
            );
            charge.details.push(yearlyDetails);
        }
    }

    // saveDetailsActivity(detailsItems, activityLine) {
    //     activityLine.details = detailsItems;
    // }

    // saveDetailsCharge(detailsItems, chargeLine) {
    //     chargeLine.details = detailsItems;
    // }

    addStaff() {
        this.formBff.staff.push(JSON.parse(JSON.stringify(this.blankStaff)));
    }

    updateFirstYearTotalGrossSalary(item) {
        item.years[0].totalAmount = Math.round(item.years[0].individualAmount * item.number);
        this.updateStaffAmounts(item, 1);
    }

    updateFirstYearMonthlyGrossSalaryAndAmounts(item) {
        item.years[0].individualAmount = Math.round(item.years[0].totalAmount / item.number);
        this.updateStaffAmounts(item, 1);
    }

    updateStaffFurtherPercentages(item) {
        // for staff: copy the unique augmentation percentage to all the year cells to use the same calculations methods used for activity or charge
        for (let yearIndex = 2; yearIndex < item.years.length; yearIndex++) {
            item.years[yearIndex].evolutionPercentage = item.years[1].evolutionPercentage;
        }
        this.updateStaffAmounts(item, 1);
    }

    updateStaffAmounts(item, startIndex) {
        const yearsLength = item.years.length;
        for (let yearIndex = startIndex; yearIndex < yearsLength; yearIndex++) {
            let year = item.years[yearIndex];
            year.totalAmount = Math.round(
                item.years[yearIndex - 1].totalAmount * (1 + year.evolutionPercentage / 100),
            );
            year.individualAmount = Math.round(year.totalAmount / item.number);
        }
    }

    buildStaffDefaultDetails(item) {
        let details = [];
        const previousDetails = JSON.parse(JSON.stringify(item.details));
        for (let yearIndex = 0; yearIndex < 5; yearIndex++) {
            let detailsYear = [];
            const yearlyPreviousDetails = previousDetails[yearIndex];
            detailsYear = buildStaffYearlyDetailsItems(
                item,
                yearIndex,
                yearlyPreviousDetails,
                this.parameters,
                this.date,
            );
            details.push(detailsYear);
        }
        item.details = details;
    }

    round(number, decimalNumber) {
        const factor = Math.pow(10, decimalNumber);
        return Math.round(number * factor) / factor;
    }

    deleteLine(lineIndex) {
        let listToModify = [];
        if (this.step === "1") {
            if (this.activeItemType === "capitalContribution") {
                listToModify = this.formBff.fundings.capitalContributions;
            } else if (this.activeItemType === "currentAccountContribution") {
                listToModify = this.formBff.fundings.currentAccountContributions;
            } else if (this.activeItemType === "loan") {
                listToModify = this.formBff.fundings.loans;
            } else if (this.activeItemType === "investmentGrant") {
                listToModify = this.formBff.fundings.investmentGrants;
            }
        } else if (this.step === "2") {
            listToModify = this.formBff.activities;
        } else if (this.step === "3") {
            if (this.activeItemType === "recurringCharge") {
                listToModify = this.formBff.charges.recurringCharges;
            } else if (this.activeItemType === "uniqueCharge") {
                listToModify = this.formBff.charges.uniqueCharges;
            }
        } else if (this.step === "4") {
            listToModify = this.formBff.staff;
        }
        listToModify.splice(lineIndex, 1);
    }

    copyValues(blankObject, object) {
        for (const key in object) {
            if (blankObject[key] === undefined) {
                delete object[key];
            }
        }
        for (const key in blankObject) {
            object[key] = blankObject[key];
        }
    }

    reinitializeLine(lineIndex) {
        let reinitializationValues = {};
        let listToModify = [];
        if (this.step === "3") {
            if (this.activeItemType === "capitalContribution") {
                reinitializationValues = JSON.parse(JSON.stringify(this.blankCapitalContribution));
                listToModify = this.formBff.fundings.capitalContributions;
            } else if (this.activeItemType === "currentAccountContribution") {
                reinitializationValues = JSON.parse(
                    JSON.stringify(this.blankCurrentAccountContribution),
                );
                listToModify = this.formBff.fundings.currentAccountContributions;
            } else if (this.activeItemType === "loan") {
                reinitializationValues = JSON.parse(
                    JSON.stringify(this.formBff.fundings.blankLoan),
                );
                listToModify = this.formBff.fundings.loans;
            } else if (this.activeItemType === "investmentGrant") {
                reinitializationValues = JSON.parse(JSON.stringify(this.blankInvestmentGrant));
                listToModify = this.formBff.fundings.investmentGrants;
            }
        } else if (this.step === "4") {
            reinitializationValues = JSON.parse(JSON.stringify(this.blankActivity));
            listToModify = this.formBff.activities;
        } else if (this.step === "5") {
            if (this.activeItemType === "recurringCharge") {
                reinitializationValues = JSON.parse(JSON.stringify(this.blankCharge));
                listToModify = this.formBff.charges.recurringCharges;
            } else if (this.activeItemType === "uniqueCharge") {
                reinitializationValues = JSON.parse(JSON.stringify(this.blankInvestment));
                listToModify = this.formBff.charges.uniqueCharges;
            }
        } else if (this.step === "6") {
            reinitializationValues = JSON.parse(JSON.stringify(this.blankStaff));
            listToModify = this.formBff.staff;
        }
        this.copyValues(reinitializationValues, listToModify[lineIndex]);
    }

    transformGapToDate(gapInMonths) {
        return moment(this.date).add(gapInMonths, "months").format();
    }

    transformDateToGap(item) {
        const monthDiff = moment(this.dateToAssign).diff(moment(this.date));
        const duration = moment.duration(monthDiff).asMonths();
        item.monthGap = duration;
    }

    assignItemDate(date) {
        this.dateToAssign = date;
    }

    areAllSalariesBosses() {
        const staffList = this.formBff.staff;
        if (staffList.length < 1) {
            return false;
        }
        for (const staff of staffList) {
            if (!staff.isBoss) {
                return false;
            }
        }
        return true;
    }

    // existingPartition(partitionName) {
    //     for (let partitionIndex = 0; partitionIndex < this.partitionTags.length; partitionIndex++) {
    //         if (this.partitionTags[partitionIndex].name === partitionName) {
    //             return {
    //                 bool: true,
    //                 index: partitionIndex
    //             }
    //         }
    //     }
    //     return {
    //         bool: false,
    //         index: null
    //     }
    // }

    initializeDefaultTag() {
        // if (!this.defaultTag && this.selectedPartition) {
        //     return null;
        // }
        // const tag = this.defaultTag;
        const tag = null;
        // this.blankInvestment.tag = tag;
        // this.blankCapitalContribution.tag = tag;
        // this.blankCurrentAccountContribution.tag = tag;
        // this.blankLoan.tag = tag;
        // this.blankInvestmentGrant.tag = tag;
        // this.blankActivity.tag = tag;
        // this.blankCharge.tag = tag;
        // this.blankStaff.tag = tag;
        for (const capitalContribution of this.formBff.fundings.capitalContributions) {
            if (!this.checkTag(capitalContribution)) {
                capitalContribution.tag = tag;
            }
        }
        for (const currentAccountContribution of this.formBff.fundings
            .currentAccountContributions) {
            if (!this.checkTag(currentAccountContribution)) {
                currentAccountContribution.tag = tag;
            }
        }
        for (const loan of this.formBff.fundings.loans) {
            if (!this.checkTag(loan)) {
                loan.tag = tag;
            }
        }
        for (const investmentGrant of this.formBff.fundings.investmentGrants) {
            if (!this.checkTag(investmentGrant)) {
                investmentGrant.tag = tag;
            }
        }
        for (const activity of this.formBff.activities) {
            if (!this.checkTag(activity)) {
                activity.tag = tag;
            }
        }
        for (const recurringCharge of this.formBff.charges.recurringCharges) {
            if (!this.checkTag(recurringCharge)) {
                recurringCharge.tag = tag;
            }
        }
        for (const uniqueCharge of this.formBff.charges.uniqueCharges) {
            if (!this.checkTag(uniqueCharge)) {
                uniqueCharge.tag = tag;
            }
        }
        for (const staff of this.formBff.staff) {
            if (!this.checkTag(staff)) {
                staff.tag = tag;
            }
        }
    }

    async updateTagsSelection(item) {
        const newValue = item.tag;
        let newId = "new" + this.tagsCreationCounter; // not useful to intitialize like this, "" would be ok
        for (const existingTag of this.tagsSelection) {
            if (existingTag === newValue || existingTag.name === newValue) {
                return null;
            }
        }
        const result = await this.$apollo.mutate({
            mutation: CREATE_TAG,
            variables: {
                name: newValue,
                companyId: this.selectedCompany.id,
                partitionConnect: { connect: { id: this.selectedPartition } },
            },
        });
        if (result && result.data && result.data.createTag && result.data.createTag.id) {
            newId = result.data.createTag.id;
        }
        const newTag = {
            id: newId,
            name: newValue,
        };
        this.tagsCreationCounter += 1;
        this.tagsSelection.push(newTag);
        item.tag = newTag;
    }

    // tagsMutationToIds() {
    //     for (const capitalContribution of this.formBff.fundings.capitalContributions) {
    //         const tagObject = capitalContribution.tag;
    //         if (tagObject && tagObject.id) {
    //             capitalContribution.tag = tagObject.id;
    //         } else {
    //             capitalContribution.tag = "";
    //         }
    //     }
    //     for (const currentAccountContribution of this.formBff.fundings.currentAccountContributions) {
    //         const tagObject = currentAccountContribution.tag;
    //         if (tagObject && tagObject.id) {
    //             currentAccountContribution.tag = tagObject.id;
    //         } else {
    //             currentAccountContribution.tag = "";
    //         }
    //     }
    //     for (const loan of this.formBff.fundings.loans) {
    //         const tagObject = loan.tag;
    //         if (tagObject && tagObject.id) {
    //             loan.tag = tagObject.id;
    //         } else {
    //             loan.tag = "";
    //         }
    //     }
    //     for (const investmentGrant of this.formBff.fundings.investmentGrants) {
    //         const tagObject = investmentGrant.tag;
    //         if (tagObject && tagObject.id) {
    //             investmentGrant.tag = tagObject.id;
    //         } else {
    //             investmentGrant.tag = "";
    //         }
    //     }
    //     for (const activity of this.formBff.activities) {
    //         const tagObject = activity.tag;
    //         if (tagObject && tagObject.id) {
    //             activity.tag = tagObject.id;
    //         } else {
    //             activity.tag = "";
    //         }
    //     }
    //     for (const recurringCharge of this.formBff.charges.recurringCharges) {
    //         const tagObject = recurringCharge.tag;
    //         if (tagObject && tagObject.id) {
    //             recurringCharge.tag = tagObject.id;
    //         } else {
    //             recurringCharge.tag = "";
    //         }
    //     }
    //     for (const uniqueCharge of this.formBff.charges.uniqueCharges) {
    //         const tagObject = uniqueCharge.tag;
    //         if (tagObject && tagObject.id) {
    //             uniqueCharge.tag = tagObject.id;
    //         } else {
    //             uniqueCharge.tag = "";
    //         }
    //     }
    //     for (const staff of this.formBff.staff) {
    //         const tagObject = staff.tag;
    //         if (tagObject && tagObject.id) {
    //             staff.tag = tagObject.id;
    //         } else {
    //             staff.tag = "";
    //         }
    //     }
    // }

    checkTag(budgetLine) {
        // if the line possess a tag in the selected partition, do nothing
        // if not, assign the default tag
        let checked = false;
        for (const partition of this.partitionTags) {
            if (partition.id === this.selectedPartition) {
                for (const tag of partition.tags) {
                    if (tag === budgetLine.tag) {
                        checked = true;
                        break;
                    }
                }
                break;
            }
        }
        return checked;
    }

    deleteSalesAccountColumn() {
        let columnIndex;
        for (let index = 0; index < this.activitiesHeaders.length; index++) {
            if (this.activitiesHeaders[index].value === "salesAccount") {
                columnIndex = index;
                break;
            }
        }
        this.activitiesHeaders.splice(columnIndex, 1);
    }

    @Watch("selectedPartition")
    updateAllHeaders() {
        if (this.selectedPartition) {
            this.lengthenHeaders();
        } else {
            this.shortenHeaders();
        }
    }

    // updateBlankLines() {
    //     this.blankInvestment = {
    //         isLineReported: false,
    //         amountNM1: null,
    //         detailsNM1: [],
    //         activeReporting: null,
    //         tag: null,
    //         title: null,
    //         nature: "Incorporel",
    //         monthGap: 0,
    //         // date: this.date,
    //         amount: 0,
    //         staggering: "Aucun",
    //         amortizationLaw: "Aucun",
    //         staggeringOffset: 0,
    //         staggeringDuration: 12,
    //         paymentNumber: 1,
    //         paymentSpacing: 1,
    //         vatRate: this.parameters.vatImmo,
    //         vatCollectionTime: "Au décaissement"
    //     }
    //     this.blankCapitalContribution = {
    //         isLineReported: false,
    //         tag: null,
    //         title: null,
    //         monthGap: 0,
    //         // date: this.date,
    //         amount: 0
    //     }
    //     this.blankCurrentAccountContribution = {
    //         isLineReported: false,
    //         tag: null,
    //         name: null,
    //         monthGap: 0,
    //         // date: this.date,
    //         amount: 0
    //     }
    //     this.blankLoan = {
    //         isLineReported: false,
    //         tag: null,
    //         title: null,
    //         details: [],
    //         monthGap: 0,
    //         // date: this.date,
    //         amount: 0,
    //         rate: 0,
    //         duration: 12,
    //         periodicity: 12,
    //         insuranceRate: 0,
    //         monthlyAmount: 0,
    //         totalCost: 0,
    //     }
    //     this.blankInvestmentGrant = {
    //         isLineReported: false,
    //         tag: null,
    //         title: null,
    //         monthGap: 0,
    //         // date: this.date,
    //         amount: 0,
    //         amortizationLaw: "Linéaire",
    //         amortizationDuration: 12
    //     }
    //     this.blankActivity = {
    //         isLineReported: false,
    //         amountNM1: null,
    //         detailsNM1: [],
    //         activeReporting: null,
    //         tag: null,
    //         title: null,
    //         // sector: "Services",
    //         salesAccount: null,
    //         details: [],
    //         years: [
    //             {
    //                 title: "Montant N",
    //                 amount: 0,
    //                 evolutionPercentage: null
    //             },
    //             {
    //                 title: "Montant N+1",
    //                 amount: 0,
    //                 evolutionPercentage: 0,
    //             },
    //             {
    //                 title: "Montant N+2",
    //                 amount: 0,
    //                 evolutionPercentage: 0,
    //             }
    //         ],
    //         marginRate: 100,
    //         vatRate: this.parameters.vatSell,
    //         paymentDelay: this.parameters.paymentDelayClient,
    //         vatCollectionTime : "Au décaissement"
    //     }
    //     this.blankCharge = {
    //         isLineReported: false,
    //         amountNM1: null,
    //         detailsNM1: [],
    //         activeReporting: null,
    //         tag: null,
    //         title: null,
    //         details: [],
    //         years: [
    //             {
    //                 title: "Montant N",
    //                 amount: 0,
    //                 evolutionPercentage: null
    //             },
    //             {
    //                 title: "Montant N+1",
    //                 amount: 0,
    //                 evolutionPercentage: 0
    //             },
    //             {
    //                 title: "Montant N+2",
    //                 amount: 0,
    //                 evolutionPercentage: 0,
    //             }
    //         ],
    //         // fixedPercentage: 100,
    //         frequency: 12,
    //         paymentDelay: this.parameters.paymentDelaySupplierPurchase,
    //         vatRate: this.parameters.vatPurchase,
    //         vatCollectionTime: "Au décaissement"
    //     }
    //     this.blankStaff = {
    //         isLineReported: false,
    //         tag: null,
    //         isBoss: false,
    //         title: null,
    //         number: 1,
    //         details: [],
    //         years: [
    //             {
    //                 title: "Salaire N",
    //                 individualAmount: 0,
    //                 totalAmount: 0,
    //                 evolutionPercentage: null
    //             },
    //             {
    //                 title: "Salaire N+1",
    //                 individualAmount: 0,
    //                 totalAmount: 0,
    //                 evolutionPercentage: 2.0
    //             },
    //             {
    //                 title: "Salaire N+2",
    //                 individualAmount: 0,
    //                 totalAmount: 0,
    //                 evolutionPercentage: 2.0,
    //             }
    //         ],
    //         wagesTax: this.parameters.incomeChargeRateEmployee,
    //         employerTax: this.parameters.employerChargeRateEmployee,
    //         globalTax: this.parameters.globalTax
    //     }
    // }

    // async upsertRelatedBfaa() {
    //     this.validLoading = true;
    //     this.transformTags();
    //     await this.saveBudgetForm();
    //     // if (this.newBudgetId) {
    //     //     this.$emit("budget-created", { date: this.date, id: this.newBudgetId, name: this.budgetName, type: 'FORM_FULL' });
    //     //     this.newBudgetId = "";
    //     // } else { // if (this.budgetModified)
    //     //     this.$emit("budget-modified", { date: this.date, id: this.budgetId, name: this.budgetName, type: 'FORM_FULL' });
    //     // }
    //     this.validLoading = false;
    //     this.$emit("upsert-bfaa", this.relatedBfaaId)
    // }

    // createFieldIsLineReported() {
    //     for (const datasetName of ["capitalContributions", "currentAccountContributions", "loans", "investmentGrants"]) {
    //         for (const line of this.formBff.fundings[datasetName]) {
    //             if (line.isLineReported === null || line.isLineReported === undefined) {
    //                 line.isLineReported = false;
    //             }
    //         }
    //     }
    //     for (const datasetName of ["activities", "staff"]) {
    //         for (const line of this.formBff[datasetName]) {
    //             if (line.isLineReported === null || line.isLineReported === undefined) {
    //                 line.isLineReported = false;
    //             }
    //         }
    //     }
    //     for (const datasetName of ["recurringCharges", "uniqueCharges"]) {
    //         for (const line of this.formBff.charges[datasetName]) {
    //             if (line.isLineReported === null || line.isLineReported === undefined) {
    //                 line.isLineReported = false;
    //             }
    //         }
    //     }
    // }

    disableYearlyAmount(line, yearIndex) {
        if (!line.details || !line.details[yearIndex]) {
            return false;
        } else {
            return line.details[yearIndex][0].uneditedCount <= 0;
        }
    }

    updateAllWhenFirstYearChange(item, isAmountChanged) {
        let year = item.years[0];
        if (isAmountChanged) {
            if (item.amountNM1 && item.amountNM1 !== 0) {
                year.evolutionPercentage = (100 * (year.amount / item.amountNM1 - 1)).toFixed(1);
            } else {
                year.evolutionPercentage = null;
            }
        } else {
            year.amount = (item.amountNM1 * (1 + year.evolutionPercentage / 100)).toFixed(1);
        }
        this.updateAmountsWhenPercentageChange(item, 1);
    }

    // initialize form with the new bfaa format

    unpackInitializationPackage() {
        if (this.initializationPackage) {
            this.blankCapitalContribution = this.initializationPackage.capitalContribution;
            this.blankCurrentAccountContribution =
                this.initializationPackage.currentAccountContribution;
            this.blankLoan = this.initializationPackage.loan;
            this.blankInvestmentGrant = this.initializationPackage.investmentGrant;
            this.blankActivity = this.initializationPackage.activity;
            this.blankCharge = this.initializationPackage.recurringCharge;
            this.blankInvestment = this.initializationPackage.uniqueCharge;
            this.blankStaff = this.initializationPackage.staff;
        } else {
            debugger;
        }
    }

    unpackHeadersPackage() {
        this.activitiesHeaders = this.headersPackage.activities;
        this.chargesHeaders = this.headersPackage.charges;
    }

    // reinitializeForm() {
    //     this.$emit("reinitialize-form")
    // }

    unactiveReporting(item) {
        // when unactivated, reset the details as if they were no more dependent of the NM1
        item.details = null;
        if (this.step === "2") {
            this.buildActivityDefaultDetails(item);
        } else if (this.step === "3") {
            this.buildChargeDefaultDetails(item);
        } else if (this.step === "4") {
            this.buildStaffDefaultDetails(item);
        }
    }

    activeReporting(item) {
        // when activated, mark percentages as fixed values (optionnal), and disable everything but yearly amounts which influences monthly amounts
        // copying the percentages from detailsNM1
        const isActivity = item.details[0].length === 3;
        // computing monthly amounts (and margins if needed) according to yearly amounts and percentages
        const details = [];
        for (let yearIndex = 0; yearIndex < item.years.length; yearIndex++) {
            const yearlyDetails = isActivity
                ? buildActivityYearlyDetailsItems(
                      item,
                      yearIndex,
                      item.detailsNM1[0],
                      this.parameters,
                      this.date,
                  )
                : buildChargeYearlyDetailsItems(
                      item,
                      yearIndex,
                      item.detailsNM1[0],
                      this.parameters,
                      this.date,
                  );
            details.push(yearlyDetails);
        }
        item.details = details;
    }

    onReportingChanged(item) {
        if (item.activeReporting) {
            this.activeReporting(item);
        } else {
            this.unactiveReporting(item);
        }
    }

    modifyDetails(item, argument, method1, method2) {
        if (item.activeReporting) {
            method1(item, argument);
            this.activeReporting(item);
        } else {
            method1(item, argument);
            method2(item);
        }
    }

    checkFirstYearEvolutionPercentage() {
        for (const activity of this.formBff.activities) {
            if (!activity.amountNM1 || activity.amountNM1 === 0) {
                activity.years[0].evolutionPercentage = null;
            }
        }
        for (const charge of this.formBff.charges.recurringCharges) {
            if (!charge.amountNM1 || charge.amountNM1 === 0) {
                charge.years[0].evolutionPercentage = null;
            }
        }
        // for (const staff of this.formBff.staff) {
        //     if (!staff.amountNM1) {
        //         staff.years[0].evolutionPercentage = null
        //     }
        // }
    }

    onValueReported() {
        // test whether modification is made in formBff despite the emission and copying
        // if not, change the path variable adding the dataset and object index to look for it in formBff
        // const item = this.pathToActiveObject.item
        // const yearIndex = this.pathToActiveObject.yearIndex
        // const modifiedIndex = this.pathToActiveObject.monthIndex
        // for (let reportIndex = modifiedIndex+1; reportIndex < item.details[yearIndex][0].months.length; reportIndex++) {
        //     const month = item.details[yearIndex][0].months[reportIndex]
        //     month.amount = this.pathToActiveObject.valueToReport
        //     month.manuallyModified = true
        //     month.edited = true
        // }
        // this.incrementYearlyTotal(item, yearIndex)
        // this.buildDefaultDetails(item, this.pathToActiveObject.itemType)
        // this.displayFillingOptions = false
        this.displayStaggeringDialog = true;
    }

    buildDefaultDetails(item, itemType) {
        if (itemType === "activity") {
            this.buildActivityDefaultDetails(item);
        } else if (itemType === "charge") {
            this.buildChargeDefaultDetails(item);
        } else if (itemType === "staff") {
            this.buildStaffDefaultDetails(item);
        }
    }

    onStoreActiveDetails(event) {
        this.pathToActiveObject = event;
        this.displayFillingOptions = true;
    }

    incrementYearlyTotal(item, yearIndex, amountsToZero?: boolean) {
        // function only applies for activities and charges, there is no such problem to solve with staff
        // search the value to affect to the yearly total
        let editedSum = 0;
        let uneditedSum = 0;
        let existLeftEditable = false;
        for (const month of item.details[yearIndex][0].months) {
            if (month.edited) {
                editedSum += month.amount;
            } else {
                uneditedSum += parseFloat(month.amount);
                existLeftEditable = true;
            }
        }
        const year = item.years[yearIndex];
        if (editedSum > year.amount || !existLeftEditable) {
            year.amount = amountsToZero ? editedSum : editedSum + uneditedSum;
            // this.updateAllWhenAmountChange(item, yearIndex+1)
            // unlike the manual modification of yearly amounts, this process only modify the current amount and the related evolution percentages, not the other yearly amounts
            if (yearIndex > 0) {
                year.evolutionPercentage =
                    100 * (year.amount / item.years[yearIndex - 1].amount - 1);
            } else if (yearIndex === 0 && item.amountNM1) {
                year.evolutionPercentage = 100 * (year.amount / item.amountNM1 - 1);
            }
            if (yearIndex < item.years.length - 1) {
                item.years[yearIndex + 1].evolutionPercentage =
                    100 * (item.years[yearIndex + 1].amount / year.amount - 1);
            }
        }
    }

    validStaggering() {
        const mode = this.staggeringModification;
        const item = this.pathToActiveObject.item;
        const firstYearIndex = this.pathToActiveObject.yearIndex;
        const modifiedIndex = this.pathToActiveObject.monthIndex;
        const mLimitDate =
            this.staggeringPeriod === "custom" ? moment(this.staggeringEndDate) : undefined;
        const limitYear =
            this.staggeringPeriod === "exercise" ? firstYearIndex + 1 : item.years.length;
        const increment =
            this.staggeringModification === "percentage"
                ? this.staggeringPercentage
                : this.staggeringModification === "amount"
                  ? this.staggeringAmount
                  : undefined;
        const firstStaggeringYearMonthNumber =
            item.details[this.pathToActiveObject.yearIndex][0].months.length;
        let toBreak = false;
        let monthCounter = 1;
        let reportValue = this.pathToActiveObject.valueToReport;
        for (let yearIndex = firstYearIndex; yearIndex < limitYear; yearIndex++) {
            const startIndex = yearIndex === firstYearIndex ? modifiedIndex + 1 : 0;
            for (
                let reportIndex = startIndex;
                reportIndex < item.details[yearIndex][0].months.length;
                reportIndex++
            ) {
                const month = item.details[yearIndex][0].months[reportIndex];
                if (mLimitDate && moment(month.date).isAfter(mLimitDate)) {
                    toBreak = true;
                    break;
                }
                reportValue = this.shouldIncrementReportValue(
                    reportValue,
                    mode,
                    monthCounter,
                    firstStaggeringYearMonthNumber,
                );
                month.amount = Math.round(reportValue);
                month.manuallyModified = true;
                month.edited = true;
                monthCounter++;
            }
            this.incrementYearlyTotal(item, yearIndex);
            if (toBreak) {
                break;
            }
        }
        this.buildDefaultDetails(item, this.pathToActiveObject.itemType);
        this.closeStaggering();
    }

    shouldIncrementReportValue(value, mode, monthCounter, fsymn) {
        if (this.staggeringModificationFrequency < 0) {
            if (monthCounter === 0) {
                return this.incrementReportValue(value, mode);
            }
        } else if (this.staggeringModificationFrequency === 0) {
            if (monthCounter - fsymn + (this.pathToActiveObject.monthIndex % 12) === 0) {
                return this.incrementReportValue(value, mode);
            }
        } else if (monthCounter % this.staggeringModificationFrequency === 0) {
            return this.incrementReportValue(value, mode);
        } else {
            return value;
        }
    }

    incrementReportValue(value, mode) {
        if (mode === "percentage") {
            return value * (1 + this.staggeringPercentage / 100);
        } else if (mode === "amount") {
            return value + this.staggeringAmount;
        } else {
            return value;
        }
    }

    closeStaggering() {
        this.staggeringModification = "equal";
        this.staggeringPeriod = "exercise";
        this.staggeringEndDate = moment().format();
        this.staggeringPercentage = 0;
        this.staggeringAmount = 0;
        this.staggeringModificationFrequency = -1;
        this.staggeringStep = 1;
        this.displayStaggeringDialog = false;
    }
}

export default toNative(BudgetFormFull);
</script>

<style></style>
